import { Spinner as Spinner$1 } from './Spinner.js';
import { SpinnerFlex } from './SpinnerFlex.js';

const Spinner = Object.assign(Spinner$1, {
    Flex: SpinnerFlex,
});

export { Spinner };
